import { HttpErrorResponse } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { httpErrorToApiError } from '@nano/core/api';

@Pipe({
  name: 'errorMessage',
  standalone: false
})
export class ErrorMessagePipe implements PipeTransform {
  transform(value: HttpErrorResponse): string {
    const apiError = httpErrorToApiError(value);
    return apiError.message || '';
  }
}
